module.exports = {
	"contractName": "PaperScissorsStoneFactory",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "createInstance",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_instance",
					"type": "address"
				},
				{
					"name": "_player",
					"type": "address"
				}
			],
			"name": "validateInstance",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "89:388:21:-;;;501:5:29;:18;;-1:-1:-1;;;;;;501:18:29;509:10;501:18;;;89:388:21;;;;;;",
	"deployedSourceMap": "89:388:21:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;137:129;;-1:-1:-1;;;;;137:129:21;;;;;;;;;-1:-1:-1;;;;;137:129:21;;;;;;;;;;;;;;238:20:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;238:20:29;;;;270:204:21;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;270:204:21;-1:-1:-1;;;;;270:204:21;;;;;;;;;;;;;;;;;;;;;;;;;;;;832:169:29;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;832:169:29;-1:-1:-1;;;;;832:169:29;;;;;;;137:129:21;202:7;237:24;;:::i;:::-;;;;;;;;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;-1:-1;230:31:21;137:129;-1:-1:-1;;137:129:21:o;238:20:29:-;;;-1:-1:-1;;;;;238:20:29;;:::o;270:204:21:-;356:4;383:27;432:9;383:59;;455:8;-1:-1:-1;;;;;455:12:21;;:14;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;455:14:21;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;455:14:21;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;-1:-1;455:14:21;;270:204;-1:-1:-1;;;;270:204:21:o;832:169:29:-;653:5;;-1:-1:-1;;;;;653:5:29;639:10;:19;631:28;;;;;;-1:-1:-1;;;;;908:22:29;;;;900:31;;;;;;958:5;;;937:37;;-1:-1:-1;;;;;937:37:29;;;;958:5;;;937:37;;;980:5;:16;;-1:-1:-1;;980:16:29;-1:-1:-1;;;;;980:16:29;;;;;;;;;;832:169::o;89:388:21:-;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.24;\n\nimport \"./base/Level.sol\";\nimport \"./PaperScissorsStone.sol\";\n\ncontract PaperScissorsStoneFactory is Level {\n  function createInstance(address _player) public payable returns (address) {\n    _player;\n    return new PaperScissorsStone();\n  }\n\n  function validateInstance(address _instance, address _player)\n    public\n    returns (bool)\n  {\n    _player;\n    PaperScissorsStone instance = PaperScissorsStone(_instance);\n    return instance.win();\n  }\n\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStoneFactory.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStoneFactory.sol",
		"exportedSymbols": {
			"PaperScissorsStoneFactory": [
				2113
			]
		},
		"id": 2114,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2072,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:21"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2073,
				"nodeType": "ImportDirective",
				"scope": 2114,
				"sourceUnit": 2867,
				"src": "26:26:21",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStone.sol",
				"file": "./PaperScissorsStone.sol",
				"id": 2074,
				"nodeType": "ImportDirective",
				"scope": 2114,
				"sourceUnit": 2071,
				"src": "53:34:21",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2075,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "127:5:21",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2076,
						"nodeType": "InheritanceSpecifier",
						"src": "127:5:21"
					}
				],
				"contractDependencies": [
					2070,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2113,
				"linearizedBaseContracts": [
					2113,
					2866,
					2922
				],
				"name": "PaperScissorsStoneFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2089,
							"nodeType": "Block",
							"src": "211:55:21",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2083,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2078,
										"src": "217:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2084,
									"nodeType": "ExpressionStatement",
									"src": "217:7:21"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 2086,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "237:22:21",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_PaperScissorsStone_$2070_$",
												"typeString": "function () returns (contract PaperScissorsStone)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2085,
												"name": "PaperScissorsStone",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2070,
												"src": "241:18:21",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
													"typeString": "contract PaperScissorsStone"
												}
											}
										},
										"id": 2087,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "237:24:21",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
											"typeString": "contract PaperScissorsStone"
										}
									},
									"functionReturnParameters": 2082,
									"id": 2088,
									"nodeType": "Return",
									"src": "230:31:21"
								}
							]
						},
						"documentation": null,
						"id": 2090,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2079,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2078,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2090,
									"src": "161:15:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2077,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "161:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "160:17:21"
						},
						"payable": true,
						"returnParameters": {
							"id": 2082,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2081,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2090,
									"src": "202:7:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2080,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "202:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "201:9:21"
						},
						"scope": 2113,
						"src": "137:129:21",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2111,
							"nodeType": "Block",
							"src": "364:110:21",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2099,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2094,
										"src": "370:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2100,
									"nodeType": "ExpressionStatement",
									"src": "370:7:21"
								},
								{
									"assignments": [
										2102
									],
									"declarations": [
										{
											"constant": false,
											"id": 2102,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 2112,
											"src": "383:27:21",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
												"typeString": "contract PaperScissorsStone"
											},
											"typeName": {
												"contractScope": null,
												"id": 2101,
												"name": "PaperScissorsStone",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2070,
												"src": "383:18:21",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
													"typeString": "contract PaperScissorsStone"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2106,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2104,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2092,
												"src": "432:9:21",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2103,
											"name": "PaperScissorsStone",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2070,
											"src": "413:18:21",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_PaperScissorsStone_$2070_$",
												"typeString": "type(contract PaperScissorsStone)"
											}
										},
										"id": 2105,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "413:29:21",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
											"typeString": "contract PaperScissorsStone"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "383:59:21"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 2107,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2102,
												"src": "455:8:21",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
													"typeString": "contract PaperScissorsStone"
												}
											},
											"id": 2108,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "win",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2069,
											"src": "455:12:21",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$__$returns$_t_bool_$",
												"typeString": "function () external returns (bool)"
											}
										},
										"id": 2109,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "455:14:21",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2098,
									"id": 2110,
									"nodeType": "Return",
									"src": "448:21:21"
								}
							]
						},
						"documentation": null,
						"id": 2112,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2095,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2092,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2112,
									"src": "296:17:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2091,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "296:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2094,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2112,
									"src": "315:15:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2093,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "315:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "295:36:21"
						},
						"payable": false,
						"returnParameters": {
							"id": 2098,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2097,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2112,
									"src": "356:4:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2096,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "356:4:21",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "355:6:21"
						},
						"scope": 2113,
						"src": "270:204:21",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 2114,
				"src": "89:388:21"
			}
		],
		"src": "0:478:21"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStoneFactory.sol",
		"exportedSymbols": {
			"PaperScissorsStoneFactory": [
				2113
			]
		},
		"id": 2114,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2072,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:21"
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/base/Level.sol",
				"file": "./base/Level.sol",
				"id": 2073,
				"nodeType": "ImportDirective",
				"scope": 2114,
				"sourceUnit": 2867,
				"src": "26:26:21",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/PaperScissorsStone.sol",
				"file": "./PaperScissorsStone.sol",
				"id": 2074,
				"nodeType": "ImportDirective",
				"scope": 2114,
				"sourceUnit": 2071,
				"src": "53:34:21",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": null,
						"baseName": {
							"contractScope": null,
							"id": 2075,
							"name": "Level",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 2866,
							"src": "127:5:21",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_Level_$2866",
								"typeString": "contract Level"
							}
						},
						"id": 2076,
						"nodeType": "InheritanceSpecifier",
						"src": "127:5:21"
					}
				],
				"contractDependencies": [
					2070,
					2866,
					2922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2113,
				"linearizedBaseContracts": [
					2113,
					2866,
					2922
				],
				"name": "PaperScissorsStoneFactory",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 2089,
							"nodeType": "Block",
							"src": "211:55:21",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2083,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2078,
										"src": "217:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2084,
									"nodeType": "ExpressionStatement",
									"src": "217:7:21"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"id": 2086,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "NewExpression",
											"src": "237:22:21",
											"typeDescriptions": {
												"typeIdentifier": "t_function_creation_nonpayable$__$returns$_t_contract$_PaperScissorsStone_$2070_$",
												"typeString": "function () returns (contract PaperScissorsStone)"
											},
											"typeName": {
												"contractScope": null,
												"id": 2085,
												"name": "PaperScissorsStone",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2070,
												"src": "241:18:21",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
													"typeString": "contract PaperScissorsStone"
												}
											}
										},
										"id": 2087,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "237:24:21",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
											"typeString": "contract PaperScissorsStone"
										}
									},
									"functionReturnParameters": 2082,
									"id": 2088,
									"nodeType": "Return",
									"src": "230:31:21"
								}
							]
						},
						"documentation": null,
						"id": 2090,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "createInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2079,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2078,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2090,
									"src": "161:15:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2077,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "161:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "160:17:21"
						},
						"payable": true,
						"returnParameters": {
							"id": 2082,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2081,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2090,
									"src": "202:7:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2080,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "202:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "201:9:21"
						},
						"scope": 2113,
						"src": "137:129:21",
						"stateMutability": "payable",
						"superFunction": 2856,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2111,
							"nodeType": "Block",
							"src": "364:110:21",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2099,
										"name": "_player",
										"nodeType": "Identifier",
										"overloadedDeclarations": [],
										"referencedDeclaration": 2094,
										"src": "370:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2100,
									"nodeType": "ExpressionStatement",
									"src": "370:7:21"
								},
								{
									"assignments": [
										2102
									],
									"declarations": [
										{
											"constant": false,
											"id": 2102,
											"name": "instance",
											"nodeType": "VariableDeclaration",
											"scope": 2112,
											"src": "383:27:21",
											"stateVariable": false,
											"storageLocation": "default",
											"typeDescriptions": {
												"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
												"typeString": "contract PaperScissorsStone"
											},
											"typeName": {
												"contractScope": null,
												"id": 2101,
												"name": "PaperScissorsStone",
												"nodeType": "UserDefinedTypeName",
												"referencedDeclaration": 2070,
												"src": "383:18:21",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
													"typeString": "contract PaperScissorsStone"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2106,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2104,
												"name": "_instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2092,
												"src": "432:9:21",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											],
											"id": 2103,
											"name": "PaperScissorsStone",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2070,
											"src": "413:18:21",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_contract$_PaperScissorsStone_$2070_$",
												"typeString": "type(contract PaperScissorsStone)"
											}
										},
										"id": 2105,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "413:29:21",
										"typeDescriptions": {
											"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
											"typeString": "contract PaperScissorsStone"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "383:59:21"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [],
										"expression": {
											"argumentTypes": [],
											"expression": {
												"argumentTypes": null,
												"id": 2107,
												"name": "instance",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2102,
												"src": "455:8:21",
												"typeDescriptions": {
													"typeIdentifier": "t_contract$_PaperScissorsStone_$2070",
													"typeString": "contract PaperScissorsStone"
												}
											},
											"id": 2108,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "win",
											"nodeType": "MemberAccess",
											"referencedDeclaration": 2069,
											"src": "455:12:21",
											"typeDescriptions": {
												"typeIdentifier": "t_function_external_nonpayable$__$returns$_t_bool_$",
												"typeString": "function () external returns (bool)"
											}
										},
										"id": 2109,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "455:14:21",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"functionReturnParameters": 2098,
									"id": 2110,
									"nodeType": "Return",
									"src": "448:21:21"
								}
							]
						},
						"documentation": null,
						"id": 2112,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "validateInstance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2095,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2092,
									"name": "_instance",
									"nodeType": "VariableDeclaration",
									"scope": 2112,
									"src": "296:17:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2091,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "296:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								},
								{
									"constant": false,
									"id": 2094,
									"name": "_player",
									"nodeType": "VariableDeclaration",
									"scope": 2112,
									"src": "315:15:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_address",
										"typeString": "address"
									},
									"typeName": {
										"id": 2093,
										"name": "address",
										"nodeType": "ElementaryTypeName",
										"src": "315:7:21",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "295:36:21"
						},
						"payable": false,
						"returnParameters": {
							"id": 2098,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2097,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 2112,
									"src": "356:4:21",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bool",
										"typeString": "bool"
									},
									"typeName": {
										"id": 2096,
										"name": "bool",
										"nodeType": "ElementaryTypeName",
										"src": "356:4:21",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "355:6:21"
						},
						"scope": 2113,
						"src": "270:204:21",
						"stateMutability": "nonpayable",
						"superFunction": 2865,
						"visibility": "public"
					}
				],
				"scope": 2114,
				"src": "89:388:21"
			}
		],
		"src": "0:478:21"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.808Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/PaperScissorsStoneFactory.json
// module id = 1050
// module chunks = 0